export default __webpack_public_path__ + "static/media/more_vert_black_24dp.f2acbf2e.svg";